import Lottie from "lottie-react";
import Banners from "./Components/contact_us.json";
const ContactUs = () => {
  return (
    <>
      <section className="bg-background">
        <div className="">
          <div className="mb-16 text-center bg-indigo-500 pt-20 pb-10">
            <h1 className="mb-4 text-3xl font-bold text-white sm:text-4xl md:text-5xl">
              Contact Us
            </h1>
            <p className="text-white mx-auto max-w-2xl text-lg">
              Ready to start your next project? Our team is here to help you
              succeed. Reach out and let's discuss how we can bring your ideas
              to life.
            </p>
          </div>
          <div className="mx-auto max-w-4xl">
            <div className="grid gap-12 lg:grid-cols-2">
              <div className="space-y-6">
                <Lottie animationData={Banners} loop={true} />
              </div>
              <div
                data-slot="card"
                className="bg-card border mb-10 text-card-foreground flex flex-col gap-6 rounded-xl py-6 shadow-none"
              >
                <div
                  data-slot="card-header"
                  className="@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6"
                >
                  <div
                    data-slot="card-title"
                    className="leading-none font-semibold"
                  >
                    Send us a message
                  </div>
                  <p className="text-muted-foreground text-sm">
                    Fill out the form below and we'll get back to you within 24
                    hours.
                  </p>
                </div>
                <div data-slot="card-content" className="px-6">
                  <form className="space-y-6">
                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <label
                          data-slot="label"
                          className="flex items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 text-sm font-medium"
                        >
                          First Name *
                        </label>
                        <input
                          data-slot="input"
                          className="file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive"
                          id="firstName"
                          placeholder="John"
                          value=""
                        />
                      </div>
                      <div className="space-y-2">
                        <label
                          data-slot="label"
                          className="flex items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 text-sm font-medium"
                        >
                          Last Name *
                        </label>
                        <input
                          data-slot="input"
                          className="file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive"
                          id="lastName"
                          placeholder="Doe"
                          value=""
                        />
                      </div>
                    </div>
                    <div className="space-y-2">
                      <label
                        data-slot="label"
                        className="flex items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 text-sm font-medium"
                      >
                        Email Address *
                      </label>
                      <input
                        type="email"
                        data-slot="input"
                        className="file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive"
                        id="email"
                        placeholder="john@company.com"
                        value=""
                      />
                    </div>

                    <div className="space-y-2">
                      <label
                        data-slot="label"
                        className="flex items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 text-sm font-medium"
                      >
                        Message *
                      </label>
                      <textarea
                        data-slot="textarea"
                        className="border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm resize-none"
                        id="message"
                        placeholder="Tell us about your project, goals, or how we can help..."
                      ></textarea>
                    </div>
                    <div className="flex items-start space-x-3">
                      <button
                        type="button"
                        role="checkbox"
                        aria-checked="false"
                        aria-required="true"
                        data-state="unchecked"
                        value="on"
                        data-slot="checkbox"
                        className="peer border-input dark:bg-input/30 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:data-[state=checked]:bg-primary data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50"
                        id="agreeToTerms"
                      ></button>
                      <input
                        type="checkbox"
                        aria-hidden="true"
                        style={{
                          position: "absolute",
                          pointerEvents: "none",
                          opacity: "0",
                          margin: "0px",
                          transform: "translateX(-100%)",
                          width: "16px",
                          height: "16px;",
                        }}
                        value="on"
                      />
                      <label
                        data-slot="label"
                        className="flex items-center gap-2 font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 text-muted-foreground text-sm leading-relaxed"
                      >
                        I agree to the{" "}
                        <a
                          href="#"
                          className="text-foreground font-medium hover:underline"
                        >
                          Terms of Service
                        </a>{" "}
                        <a
                          href="#"
                          className="text-foreground font-medium hover:underline"
                        >
                          Privacy Policy
                        </a>
                      </label>
                    </div>
                    <button
                      data-slot="button"
                      className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg:not([class*='size-'])]:size-4 shrink-0 [&amp;_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive bg-indigo-500 text-white shadow-xs hover:bg-primary/90 h-9 px-4 py-2 has-[&gt;svg]:px-3 w-full"
                      type="submit"
                    >
                      <div className="flex items-center gap-2">Submit</div>
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div className="grid gap-4 lg:grid-cols-2 mb-20">
              <div
                data-slot="card"
                className="text-card-foreground bg-gray-200 flex flex-col gap-6 rounded-xl py-6 bg-muted border-0 shadow-none"
              >
                <div data-slot="card-content" className="px-6">
                  <div className="flex items-start gap-4">
                    <div className="bg-muted text-indigo-500 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-mail size-6"
                        aria-hidden="true"
                      >
                        <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                      </svg>
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="mb-1 flex items-center gap-2">
                        <h3 className="font-semibold">Email</h3>
                      </div>
                      <p className="text-muted-foreground mb-2 text-sm">
                        Get a response within 24 hours
                      </p>
                      <a
                        href="mailto:hello@company.com"
                        className="text-sm font-medium transition-colors hover:underline"
                      >
                        support@ttm4u.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-slot="card"
                className="text-card-foreground  bg-gray-200 flex flex-col gap-6 rounded-xl py-6 bg-muted border-0 shadow-none"
              >
                <div data-slot="card-content" className="px-6">
                  <div className="flex items-start gap-4">
                    <div className="bg-muted text-indigo-500 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-messages-square size-6"
                        aria-hidden="true"
                      >
                        <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"></path>
                        <path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"></path>
                      </svg>
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="mb-1 flex items-center gap-2">
                        <h3 className="font-semibold">Live Chat</h3>
                      </div>
                      <p className="text-muted-foreground mb-2 text-sm">
                        Instant support available now
                      </p>
                      <a
                        href="#"
                        className="text-sm font-medium transition-colors hover:underline"
                      >
                        Start chatting
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-slot="card"
                className="text-card-foreground  bg-gray-200 flex flex-col gap-6 rounded-xl py-6 bg-muted border-0 shadow-none"
              >
                <div data-slot="card-content" className="px-6">
                  <div className="flex items-start gap-4">
                    <div className="bg-muted text-indigo-500 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-phone size-6"
                        aria-hidden="true"
                      >
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                      </svg>
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="mb-1 flex items-center gap-2">
                        <h3 className="font-semibold">Phone</h3>
                      </div>
                      <p className="text-muted-foreground mb-2 text-sm">
                        24X7, EST TIME
                      </p>
                      <a
                        href="tel:+15551234567"
                        className="text-sm font-medium transition-colors hover:underline"
                      >
                        +1(707)761-7464
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-slot="card"
                className="text-card-foreground  bg-gray-200 flex flex-col gap-6 rounded-xl py-6 bg-muted border-0 shadow-none"
              >
                <div data-slot="card-content" className="px-6">
                  <div className="flex items-start gap-4">
                    <div className="bg-muted text-indigo-500 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-map-pin size-6"
                        aria-hidden="true"
                      >
                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="mb-1 flex items-center gap-2">
                        <h3 className="font-semibold">Office</h3>
                      </div>
                      <p className="text-muted-foreground mb-2 text-sm">
                        Schedule an in-person meeting
                      </p>
                      <a
                        href="#"
                        className="text-sm font-medium transition-colors hover:underline"
                      >
                        12455 Mesquite st , OAK HILLS CA 92344
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="mt-12">
              <div
                data-orientation="horizontal"
                role="none"
                data-slot="separator-root"
                className="bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px mb-8"
              ></div>
              <div
                data-slot="card"
                className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 bg-muted border-0 shadow-none"
              >
                <div data-slot="card-content" className="p-6">
                  <div className="grid gap-8 md:grid-cols-2">
                    <div className="space-y-4">
                      <h3 className="text-lg font-semibold">Office Hours</h3>
                      <div className="text-muted-foreground space-y-2 text-sm">
                        <div className="flex justify-between">
                          <span>Monday - Friday</span>
                          <span>9:00 AM - 6:00 PM EST</span>
                        </div>
                        <div className="flex justify-between">
                          <span>Saturday</span>
                          <span>10:00 AM - 4:00 PM EST</span>
                        </div>
                        <div className="flex justify-between">
                          <span>Sunday</span>
                          <span>Closed</span>
                        </div>
                      </div>
                    </div>
                    <div className="space-y-4">
                      <h3 className="text-lg font-semibold">
                        Contact Information
                      </h3>
                      <div className="text-muted-foreground space-y-2 text-sm">
                        <div className="flex justify-between">
                          <span>Email</span>
                          <span>hello@company.com</span>
                        </div>
                        <div className="flex justify-between">
                          <span>Phone</span>
                          <span>+1 (555) 123-4567</span>
                        </div>
                        <div className="flex justify-between">
                          <span>Address</span>
                          <span>123 Innovation St, Tech City</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};
export default ContactUs;
